import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface LoadingSkeletonProps {
  rows?: number;
  height?: number;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ rows = 3, height = 48 }) => (
  <Box>
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={height} sx={{ mb: 1, borderRadius: 2 }} />
    ))}
  </Box>
);

export default LoadingSkeleton;
